<div class="flex w-full h-full">
  <ngx-skeleton-loader
    id="E941D4AF-C845"
    class="flex w-full"
    [theme]="_theme"
    [animation]="animation"
    [appearance]="appearance"
    [loadingText]="loadingText"
    [count]="count"
  ></ngx-skeleton-loader>
</div>